import type { PurposeKey } from './purposes';

/**
 * Purpose-first onboarding handoff. The landing captures the creator's PURPOSE before the Google sign-in
 * redirect and stashes it here; after auth, ChatWorkspace reads it once and lands the user in the ready
 * studio for that purpose. Mirrors the existing `wt_start_agent` sessionStorage pattern (ChatWorkspace).
 *
 * sessionStorage (not local) so the intent is scoped to this tab/session and never leaks across visits.
 */
const KEY = 'wt_onboarding_intent';

export interface OnboardingIntent {
  purpose: PurposeKey;
}

export function stashOnboardingIntent(intent: OnboardingIntent): void {
  try { sessionStorage.setItem(KEY, JSON.stringify(intent)); } catch { /* private mode / disabled — non-fatal */ }
}

/** Read AND clear the intent (one-shot). Returns null if absent or unparseable. */
export function takeOnboardingIntent(): OnboardingIntent | null {
  let raw: string | null = null;
  try { raw = sessionStorage.getItem(KEY); } catch { return null; }
  if (!raw) return null;
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  try {
    const parsed = JSON.parse(raw) as OnboardingIntent;
    return parsed && (parsed.purpose === 'video' || parsed.purpose === 'photobook' || parsed.purpose === 'ad')
      ? parsed : null;
  } catch { return null; }
}
